var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdpShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3327 15.1659C23.3327 20.9992 19.2493 23.9159 14.396 25.6076C14.1419 25.6937 13.8658 25.6896 13.6143 25.5959C8.74935 23.9159 4.66602 20.9992 4.66602 15.1659V6.99922C4.66602 6.6898 4.78893 6.39306 5.00772 6.17426C5.22652 5.95547 5.52326 5.83256 5.83268 5.83256C8.16602 5.83256 11.0827 4.43256 13.1127 2.65922C13.3598 2.44805 13.6743 2.33203 13.9993 2.33203C14.3244 2.33203 14.6389 2.44805 14.886 2.65922C16.9277 4.44422 19.8327 5.83256 22.166 5.83256C22.4754 5.83256 22.7722 5.95547 22.991 6.17426C23.2098 6.39306 23.3327 6.6898 23.3327 6.99922V15.1659Z",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13.9993L12.8333 16.3327L17.5 11.666",
    stroke: "currentColor",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdpShield);
export default __webpack_public_path__ + "static/media/idp-shield.da3ae6928417263a31aaa219a0e0cf8f.svg";
export { ForwardRef as ReactComponent };